import {
  Home,
  Users,
  UserCheck,
  Syringe,
  Search,
  UserPlus,
  FileText,
  HelpCircle,
  MessageCircle,
  Bell,
  LogOut,
  Cog,
  Settings,
  Shield,
  BookOpen
} from "lucide-react"

export const menuItems = [
    {
        type: 'item',
        label: 'Home',
        path: '/dashboard',
        policies: ['user:authenticated~full'],
        icon: Home
    },

    {
       type: 'item',
       label: 'Administration',
       path: '/admin',
       policies: ['admin:access~full'],
       icon: Users
    },
    {
       type: 'item',
       label: 'Provision Users',
       path: '/admin/provision-user-accounts',
       policies: ['admin:access~full'],
       icon: UserCheck
    },
    {
       type: 'item',
       label: 'Two-Factor Enrollment',
       path: '/admin/two-factor-enrollment',
       policies: ['admin:access~full'],
       icon: Shield
    },
     {
       type: 'separator',
       label: 'Candidates/Census',
       icon: UserCheck,
       submenu: [
         {
           label: 'MIST Census',
           path: '/candidates/mist',
           policies: ['program:candidate~full']
         },
         {
           label: 'FIST Candidates',
           path: '/candidates/fist',
           policies: ['program:candidate~full']
         },

         {
           label: 'DSH Diversion Candidates',
           path: '/candidates/dsh',
           policies: ['program:candidate~full']
         },
         {
            label: 'LEAD Candidates',
            path: '/candidates/lead',
            policies: ['program:candidate~full']
          },
         {
           label: 'Acute Psych Beds',
           path: '/candidates/olive',
           policies: ['program:candidate~full']
         },
         {
           label: 'Sub-Acute Psych Beds',
           path: '/candidates/olive-vista',
           policies: ['program:candidate~full']
         },
         {
           label: 'COVID-19 Jail Releases',
           path: '/candidates/covid',
           policies: ['program:candidate~full']
         },
         {
           label: 'ODR Candidates',
           path: '/candidates/odr',
           policies: ['program:candidate~full']
         },
         {
           label: 'Maternal Candidates',
           path: '/candidates/maternal',
           policies: ['program:candidate~full']
         },
         {
           label: 'Charges Manager',
           path: '/candidates/charges-manager',
           policies: ['program:candidate~full']
         },
       ]
     },
     {
       type: 'separator',
       label: 'Tools',
       icon: Cog,
       submenu: [
         {
           label: 'LA Care Tools',
           path: '/reports',
           policies: ['tools:reports:access~read']
          },
         {
           label: 'Duplicates Tool',
           path: '/reports/duplicateclients',
           policies: ['tools:duplicate~read']
         },
         {
           label: 'LAI Jail',
           path: '/candidates/lai',
           policies: ['tools:lai:jail~read']
         },
         {
           label: 'LAI Community',
           path: '/candidates/lai-community',
           policies: ['program:candidate~full']
         },
         {
           label: 'Housing Dashboard',
           path: '/tools/housing-dashboard',
           policies: ['tools:housing~full']
         },
         {
           label: 'Central Planner',
           path: '/tools/central-planner',
           policies: ['tools:centralplanner~full']
         },
         {
           label: 'Incident Reports',
           path: '/candidates/inrep',
           policies: ['tools:inrepaccess~full']
         },
         {
           label: 'Progress Reports',
           path: '/candidates/progress-report',
           policies: ['tools:progressreportaccess~full']
         },
         {
           label: 'COVID-19 Testing',
           path: '/candidates/covid-testing',
           policies: ['program:candidate~full']
         },
         {
           label: 'Quarantine Sites',
           path: '/tools/quarantine-sites',
           policies: ['tools:quarantine~full']
         },
         {
           label: 'MedCall',
           path: '/tools/medcall',
           policies: ['tools:medcall:access:~user', 'tools:medcall:access:~full']
         },
         {
           label: 'Medcall Workspace',
           path: '/tools/medcall-workspace',
           policies: ['tools:medcall:access:~user', 'tools:medcall:access:~full']
         },
         {
           label: 'DrugBank Medication Manager',
           path: '/tools/drugbank',
           policies: ['tools:drugbank~full']
         },
         {
           label: 'Court Calendar',
           path: '/tools/court-calendar',
           policies: ['tools:courtcalendar~full']
         },
         {
           label: 'User Account Requests',
           path: '/tools/user-account-requests',
           policies: ['tools:requestuser~full']
         },
         {
           label: 'Provision User Accounts',
           path: '/admin/provision-user-accounts',
           policies: ['admin:access~full']
         },
         {
           label: 'Case Conferencing',
           path: '/caseConferencing',
           policies: ['tools:caseconference~full']
         },
         {
           label: 'Documents Library',
           path: '/tools/documents-library',
           policies: ['tools:docslib:external~read', 'tools:docslib:internal~read']
         },
         {
           label: 'eFax',
           path: '/admin/efax',
           policies: ['tools:efax:access~full']
         },
         {
           label: 'Notification Log',
           path: '/tools/notification-log',
           policies: ['tools:notifications~full']
         },
         {
           label: 'Public Defenders List',
           path: '/tools/public-defenders-list',
           policies: ['tools:publicdefenderslist~full']
         },
            ]},
         {
           type: 'separator',
           label: 'Vaccines',
           icon: Syringe,
           submenu: [
         {
           label: 'Vaccine Appointments',
           path: '/vaccineAppointments',
           policies: ['program:candidate~full', 'program:candidate~full', 'program:candidate~full']
         },
         {
           label: 'Influenza Vaccine Tracking',
           path: '/candidates/influenza-vaccine',
           policies: ['program:candidate~full']
         },
         {
           label: 'COVID-19 Vaccine Tracking',
           path: '/candidates/covid-vaccine',
           policies: ['program:candidate~full']
         },
         {
           label: 'Monkeypox Vaccine Tracking',
           path: '/candidates/monkeypox-vaccine',
           policies: ['program:candidate~full']
         }
       ]
     },
    {
       type: 'separator',
       label: '',
       icon: ''
     },
     {
       type: 'item',
       label: 'Search',
       path: '/search',
       policies: ['program:participant~read'],
       icon: Search
     },
    {
       type: 'item',
       label: 'New Client',
       path: '/search',
       policies: ['program:participant~read'],
       icon: UserPlus
     },
    {
       type: 'item',
       label: 'Reports',
       path: '/reports',
       policies: ['tools:reports:access~read', 'tools:reports:access~read'],
       icon: FileText
    },
    {
       type: 'separator',
       label: 'Billing',
       icon: FileText,
       submenu: [
         {
           label: 'Billing Center',
           path: '/billing',
           policies: ['tools:billing:access~full']
         },
         {
           label: 'ECM Dashboard',
           path: '/tools/ecm-dashboard',
           policies: ['tools:billing:access~full', 'billing:ecm:dashboard~read']
         },
         {
           label: 'ECM Metrics',
           path: '/reports/ecm-metrics',
           policies: ['tools:billing:access~full']
         }
       ]
    },
     {
        type: 'item',
        label: 'Message Center',
        path: '/messages',
        policies: ['messaging:user:messages~full'],
        icon: MessageCircle
     },
     {
        type: 'item',
        label: 'Notifications',
        path: '/notifications',
        policies: ['tools:notifications~full'],
        icon: Bell
     },
     {
        type: 'item',
        label: 'Settings',
        path: '/settings',
        policies: ['user:authenticated~full'],
        icon: Settings
     },
     {
        type: 'separator',
        label: 'Help',
        icon: HelpCircle,
        submenu: [
          {
            type: 'action',
            label: 'Page Help',
            action: 'toggleHelp',
            icon: HelpCircle
          },
          {
            label: 'Support',
            path: '/support',
            anyAuthenticated: true,
            icon: HelpCircle
          },
          {
            label: 'Knowledge Base',
            path: '/support/knowledge-base',
            policies: ['tools:support:knowledgebase~read'],
            icon: BookOpen
          }
        ]
    },
    {
        type: 'action',
        label: 'Log Out',
        action: 'logout',
        icon: LogOut
    },
   ] as any; 
